var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`--current-app-sub-section-color: var(--color-section-${_vm.appSubSection})`),attrs:{"id":"app","data-app-sub-section":_vm.appSubSection}},[_c('dev-header'),_c('router-view'),_c('auth-auto-logout-overlay'),_c('service-unavailable-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }